module.exports = __webpack_public_path__ + "img/title_3.27675141.png";